import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	id                    : null,
	picture               : null,
	browser               : null,
	audioDevices          : null,
	webcamDevices         : null,
	webcamInProgress      : false,
	audioInProgress       : false,
	screenShareInProgress : false,
	isSpeaking            : false,
	isMuted               : true,
	displayName           : '',
	audioCall             : '',
	videoCall             : '',
	roomModeView          : 'democratic',
	callInprogress        : false,
	msgIndicator          : false,
	connectedAudioDevices : null,
	connectedVideoDevices : null,
	selectedDeviceId      : null,
	selectedVideoDeviceId : null,
	messageRec            : false
};

export const callSlice = createSlice({
	name     : 'call',
	initialState,
	reducers : {
		// Define your reducer functions here
		setId : (state, action) =>
		{
			state.id = action.payload;
		},
		setPicture : (state, action) =>
		{
			state.picture = action.payload;
		},
		setBrowser : (state, action) =>
		{
			state.browser = action.payload;
		},
		setAudioDevices : (state, action) =>
		{
			state.audioDevices = action.payload;
		},
		setAudioInProgress : (state, action) =>
		{
			state.audioInProgress = action.payload;
		},
		setWebcamDevices : (state, action) =>
		{
			state.webcamDevices = action.payload;
		},
		setWebcamInProgress : (state, action) =>
		{
			state.webcamInProgress = action.payload;
		},
		setScreenShareInProgress : (state, action) =>
		{
			state.screenShareInProgress = action.payload;
		},
		setIsSpeaking : (state, action) =>
		{
			state.isSpeaking = action.payload;
		},
		setIsMuted : (state, action) =>
		{
			state.isMuted = action.payload;
		},
		setDisplayName : (state, action) =>
		{
			state.displayName = action.payload;
		},
		setAudioCall : (state, action) =>
		{
			state.audioCall = action.payload;
		},
		setVideoCall : (state, action) =>
		{
			state.videoCall = action.payload;
		},
		setRoomModeView : (state, action) =>
		{
			state.roomModeView = action.payload;
		},
		setCallInProgress : (state, action) =>
		{
			state.callInprogress = action.payload;
		},
		setMsgIndicator : (state, action) =>
		{
			state.msgIndicator = action.payload;
		},
		setConnectedDevices : (state, action) =>
		{
			state.connectedAudioDevices = action.payload;
		},
		setConnectedVideoDevices : (state, action) =>
		{
			state.connectedVideoDevices = action.payload;
		},
		setselectedDeviceId : (state, action) =>
		{
			state.selectedDeviceId = action.payload;
		},
		setSelectedVideoDeviceId : (state, action) =>
		{
			state.selectedVideoDeviceId = action.payload;
		},
		setMsgRec : (state, action) =>
		{
			state.messageRec = action.payload;
		},
		setConnectionState : (state, action) =>
		{
			state.connectionState = action.payload;
		}
	}
});

export const {
	setId,
	setPicture,
	setBrowser,
	setAudioDevices,
	setAudioInProgress,
	setWebcamDevices,
	setWebcamInProgress,
	setScreenShareInProgress,
	setIsSpeaking,
	setIsMuted,
	setDisplayName,
	setAudioCall,
	setVideoCall,
	setRoomModeView,
	setCallInProgress,
	setMsgIndicator,
	setConnectedDevices,
	setselectedDeviceId,
	setConnectedVideoDevices,
	setSelectedVideoDeviceId,
	setMsgRec,
	setConnectionState
} = callSlice.actions;

export default callSlice.reducer;
